/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyContainer } from '@appCanvasCommon/graphics/FancyContainer';

export class WorldContainer extends FancyContainer {}
